import React, { lazy, Suspense } from 'react';
import StepWrapper from '../components/stepWrapper';

import WithOneOption from '../steps/withOneOption';
import MultiOptions from '../steps/multiOptions';
import WelcomeEverydoggy from '../steps/welcomeEverydoggy';
import WhatWeHaveForYou from '../steps/whatWeHaveForYou';
import TrainYourDog from '../steps/trainYourDog';
import FormingSkill from '../steps/formingSkill';
import DogName from '../steps/dogName';
import Mail from '../steps/mail';

import WithOneOptionV1 from '../steps/customV1/withOneOptionV1';
import MultiOptionsV1 from '../steps/customV1/multiOptionsV1';
import MultiOptionsV2 from '../steps/customV1/multiOptionsV2';
import DescriptionV1 from '../steps/customV1/descriptionV1';
import DescriptionV2 from '../steps/customV1/descriptionV2';
import LoaderV2 from '../steps/customV1/loader';
import MailV2 from '../steps/customV1/mail';
import StartPage from '../steps/customV1/startPage';

// import saveRandomValue from '../utils/scripts/saveRandomValue';
// import getParameterFromURL from '../utils/scripts/getParameterFromURL';

const CustomV2StartPage = lazy(() => import('../steps/customV2/startPage'));
const CustomV2StartPageV2 = lazy(() => import('../steps/customV2/startPageV2'));
const CustomV2StartPageV3 = lazy(() => import('../steps/customV2/startPageV3'));
const CustomV2StartPageV4 = lazy(() => import('../steps/customV2/startPageV4'));
const CustomV2StartPageV5 = lazy(() => import('../steps/customV2/startPageV5'));
const CustomV2StartPageV6 = lazy(() => import('../steps/customV2/startPageV6'));
const CustomV2StartPageV7 = lazy(() => import('../steps/customV2/startPageV7'));
const CustomV2StartPageV8 = lazy(() => import('../steps/customV2/startPageV8'));
const CustomV2StartPageV11 = lazy(() => import('../steps/customV2/startPageV11'));
const CustomV2StartPageV12 = lazy(() => import('../steps/customV2/startPageV12'));
const CustomV2StartPageV13 = lazy(() => import('../steps/customV2/startPageV13'));
const CustomV2StartPageV17 = lazy(() => import('../steps/customV2/startPageV17'));
const CustomV2StartPageV18 = lazy(() => import('../steps/customV2/startPageV18'));
const CustomV2StartPageV19 = lazy(() => import('../steps/customV2/startPageV19'));
const CustomV2StartPageV20 = lazy(() => import('../steps/customV2/startPageV20'));
const CustomV2StartPageV21 = lazy(() => import('../steps/customV2/startPageV21'));
const CustomV2StartPageV22 = lazy(() => import('../steps/customV2/startPageV22'));
const CustomV2StartPageV23 = lazy(() => import('../steps/customV2/startPageV23'));
const CustomV2StartPageV24 = lazy(() => import('../steps/customV2/startPageV24'));
const CustomV2StartPageV25 = lazy(() => import('../steps/customV2/startPageV25'));
const CustomV2StartPageV26 = lazy(() => import('../steps/customV2/startPageV26'));
const CustomV2StartPageV27 = lazy(() => import('../steps/customV2/startPageV27'));
const CustomV2StartPageV28 = lazy(() => import('../steps/customV2/startPageV28'));
const CustomV2StartPageV29 = lazy(() => import('../steps/customV2/startPageV29'));
const CustomV2StartPageV30 = lazy(() => import('../steps/customV2/startPageV30'));
const CustomV2StartPageV31 = lazy(() => import('../steps/customV2/startPageV31'));
const CustomV2PolicyPage = lazy(() => import('../steps/customV2/policy'));
const CustomV2PolicyPageV2 = lazy(() => import('../steps/customV2/policyV2'));
const CustomV2PolicyPageV3 = lazy(() => import('../steps/customV2/policyV3'));
const CustomV2PolicyPageV4 = lazy(() => import('../steps/customV2/policyV4'));
const CustomV2PolicyPageV5 = lazy(() => import('../steps/customV2/policyV5'));
const CustomV2VideoPolicyPage = lazy(() => import('../steps/customV2/policyVideo'));
const StartPageVideo = lazy(() => import('../steps/customV2/startPageVideo'));
const StartPageVideoV2 = lazy(() => import('../steps/customV2/startPageVideoV2'));

const WithOneOptionV2 = lazy(() => import('../steps/customV2/withOneOption'));
const WithOneOptionV3 = lazy(() => import('../steps/customV2/age'));
const WithOneOptionV4 = lazy(() => import('../steps/customV2/withOneOptionV2'));
const WithOneOptionV5 = lazy(() => import('../steps/customV2/withOneOptionV3'));
const WithOneOptionV6 = lazy(() => import('../steps/customV2/withOneOptionV4'));
const WithOneOptionV7 = lazy(() => import('../steps/customV2/withOneOptionV5'));

const DogNameV2 = lazy(() => import('../steps/customV2/name'));
const DogBreed = lazy(() => import('../steps/customV2/breed'));
const CustomV2MultiOptionsV1 = lazy(() => import('../steps/customV2/multiOptionsV1'));
const CustomV2MultiOptionsV2 = lazy(() => import('../steps/customV2/multiOptionsV2'));
const CustomV2InfoBreed = lazy(() => import('../steps/customV2/infoBreed'));
const CustomV2InfoBreedV2 = lazy(() => import('../steps/customV2/infoBreedV2'));
const CustomV2InfoBreedV3 = lazy(() => import('../steps/customV2/infoBreedV3'));
const InfoAboutOwner = lazy(() => import('../steps/customV2/infoAboutOwner'));
const InfoAboutPotty = lazy(() => import('../steps/customV2/infoAboutPotty'));
const CustomV2CreatingProgram = lazy(() => import('../steps/customV2/creatingProgram'));
const GenderV3 = lazy(() => import('../steps/customV2/genderV3'));
const BehaviorProblemV4 = lazy(() => import('../steps/customV2/behaviorProblemV4'));
const AgeV2 = lazy(() => import('../steps/customV2/ageV2'));
const AgeV3 = lazy(() => import('../steps/customV2/ageV3'));
const AgeV4 = lazy(() => import('../steps/customV2/ageV4'));
const AgeV5 = lazy(() => import('../steps/customV2/ageV5'));
const MailV3 = lazy(() => import('../steps/customV2/mail'));
const Plan = lazy(() => import('../steps/customV2/plan'));
const InfoPredict = lazy(() => import('../steps/customV2/infoPredict'));
const DateStep = lazy(() => import('../steps/customV2/date'));
const WithTrackOption = lazy(() => import('../steps/customV2/withTrackOption'));
const StartPageGender = lazy(() => import('../steps/customV2/startPageGender'));
const Quote = lazy(() => import('../steps/customV2/quote'));
const ReceiveEmail = lazy(() => import('../steps/customV2/receiveEmail'));
const GenderZw = lazy(() => import('../steps/customV2/genderZw'));
const ZwAge = lazy(() => import('../steps/customV2/zwAge'));
const SpecialOffer = lazy(() => import('../steps/customV2/specialOffer'));
const InfoThank = lazy(() => import('../steps/customV2/infoThank'));
const SpecialOfferV2 = lazy(() => import('../steps/customV2/specialOfferV2'));
const SpecialOfferV3 = lazy(() => import('../steps/customV2/specialOfferV3'));
const StartPageAge = lazy(() => import('../steps/customV2/startPageAge'));
const StartPageAgeV2 = lazy(() => import('../steps/customV2/startPageAgeV2'));
const StartPageAgeV3 = lazy(() => import('../steps/customV2/startPageAgeV3'));
const TrainingTime = lazy(() => import('../steps/customV2/trainingTime'));
const InfoAboutCrate = lazy(() => import('../steps/customV2/infoAboutCrate'));
const InfoAboutTraining = lazy(() => import('../steps/customV2/infoAboutTraining'));
const InfoAboutUnderstanding = lazy(() => import('../steps/customV2/infoAboutUnderstanding'));
const UnderstandingSummary = lazy(() => import('../steps/customV2/understandingSummary'));

const WithOneOptionV4V5 = WithOneOptionV4;
// const darkTheme = getParameterFromURL('darkTheme') === 'true';

// =====================
//  УТИЛИТЫ ДЛЯ ПРОИЗВОДИТЕЛЬНОСТИ
// =====================

const withSuspense = (node) => <Suspense fallback={null}>{node}</Suspense>;

const questionsCache = new Map();
const makeKey = (base, extras) => JSON.stringify({ base, extras });

function cachedOne(name, extras) {
  const key = makeKey(name, extras);
  if (!questionsCache.has(key)) {
    questionsCache.set(key, [
      {
        name,
        isCompleted: 'ifOneAnswerSelected',
        ...(extras || {}),
      },
    ]);
  }
  return questionsCache.get(key);
}

const pickWrapperProps = (cfg) => {
  if (!cfg) return {};
  return {
    isCurrentStepCompleted: cfg.isCurrentStepCompleted,
    customIsCompletedValidation: cfg.customIsCompletedValidation,
  };
};

const pickChildProps = (cfg) => {
  if (!cfg) return {};
  return {
    withIcon: cfg.withIcon,
    noWideIcons: cfg.noWideIcons,
    withDescriptionText: cfg.withDescriptionText,
    roundedOptions: cfg.roundedOptions,
    withWideButtons: cfg.withWideButtons,
    btn: cfg.btn,
    showBottomBar: cfg.showBottomBar,
  };
};

// 3) Универсальные фабрики
const wrapStep = (Cmp, cmpProps) => (stepData) => {
  const w = pickWrapperProps(cmpProps?.wrapper);
  const c = pickChildProps(cmpProps?.child);

  return withSuspense(
    <StepWrapper
      stepData={stepData}
      isCurrentStepCompleted={w.isCurrentStepCompleted}
      customIsCompletedValidation={w.customIsCompletedValidation}
    >
      <Cmp
        withIcon={c.withIcon}
        noWideIcons={c.noWideIcons}
        withDescriptionText={c.withDescriptionText}
        roundedOptions={c.roundedOptions}
        withWideButtons={c.withWideButtons}
        btn={c.btn}
        showBottomBar={c.showBottomBar}
      />
    </StepWrapper>,
  );
};

const wrapStepQuestions = (Cmp, qName, extras, cmpProps) => (stepData) => {
  const w = pickWrapperProps(cmpProps?.wrapper);
  const c = pickChildProps(cmpProps?.child);

  return withSuspense(
    <StepWrapper
      stepData={stepData}
      questions={cachedOne(qName, extras)}
      isCurrentStepCompleted={w.isCurrentStepCompleted}
      customIsCompletedValidation={w.customIsCompletedValidation}
    >
      <Cmp
        withIcon={c.withIcon}
        noWideIcons={c.noWideIcons}
        withDescriptionText={c.withDescriptionText}
        roundedOptions={c.roundedOptions}
        withWideButtons={c.withWideButtons}
        btn={c.btn}
        showBottomBar={c.showBottomBar}
      />
    </StepWrapper>,
  );
};

function pickStartPageCmp() {
  return CustomV2StartPageV4;
}

// “Прокладка”: получает пропсы от wrapStepQuestions и пробрасывает дальше
function DynamicCustomV2StartPage(props) {
  const Cmp = pickStartPageCmp();
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Cmp {...props} />;
}

// =====================
//  КОНФИГ КОМПОНЕНТОВ
// =====================

export const stepsComponents = {
  mail: wrapStep(Mail, { wrapper: { isCurrentStepCompleted: true } }),
  welcomeEverydoggy: wrapStep(WelcomeEverydoggy, { wrapper: { isCurrentStepCompleted: true } }),
  whatWeHaveForYou: wrapStep(WhatWeHaveForYou, { wrapper: { isCurrentStepCompleted: true } }),
  trainYourDog: wrapStep(TrainYourDog, { wrapper: { isCurrentStepCompleted: true } }),
  formingSkill: wrapStep(FormingSkill, { wrapper: { isCurrentStepCompleted: true } }),

  age: wrapStepQuestions(WithOneOption, 'age'),
  role: wrapStepQuestions(WithOneOption, 'role'),
  puppy_or_adult: wrapStepQuestions(WithOneOption, 'puppy_or_adult'),
  how_old: wrapStepQuestions(WithOneOption, 'how_old'),
  breed: wrapStepQuestions(WithOneOption, 'breed'),
  dog_name: wrapStep(DogName, { wrapper: { customIsCompletedValidation: true } }),
  goal: wrapStepQuestions(WithOneOption, 'goal'),
  biting: wrapStepQuestions(WithOneOption, 'biting'),
  potty_training: wrapStepQuestions(WithOneOption, 'potty_training'),
  commands: wrapStepQuestions(MultiOptions, 'commands'),
  commands_puppy: wrapStepQuestions(MultiOptions, 'commands_puppy'),
  being_home_alone: wrapStepQuestions(WithOneOption, 'being_home_alone'),
  being_home_alone_puppy: wrapStepQuestions(WithOneOption, 'being_home_alone_puppy'),
  hygiene: wrapStepQuestions(WithOneOption, 'hygiene'),
  chewing: wrapStepQuestions(WithOneOption, 'chewing'),
  jumping_on_people: wrapStepQuestions(WithOneOption, 'jumping_on_people'),
  being_for_food: wrapStepQuestions(WithOneOption, 'being_for_food'),
  obedience: wrapStepQuestions(WithOneOption, 'obedience'),
  picking_up_from_the_ground: wrapStepQuestions(WithOneOption, 'picking_up_from_the_ground'),

  // custom V1
  customV1_gender: wrapStepQuestions(WithOneOptionV1, 'customV1_gender', null, { child: { withIcon: true, noWideIcons: true } }),
  customV1_age: wrapStepQuestions(WithOneOptionV1, 'customV1_age'),
  customV1_breed: wrapStepQuestions(WithOneOptionV1, 'customV1_breed', null, { child: { roundedOptions: true } }),
  customV1_commands: wrapStepQuestions(MultiOptionsV1, 'customV1_commands'),
  customV1_descriptionV1: wrapStepQuestions(DescriptionV1, 'customV1_descriptionV1'),
  customV1_nervous: wrapStepQuestions(WithOneOptionV1, 'customV1_nervous', null, { child: { withIcon: true } }),
  customV1_anxious: wrapStepQuestions(WithOneOptionV1, 'customV1_anxious', null, { child: { withIcon: true } }),
  customV1_stressed: wrapStepQuestions(WithOneOptionV1, 'customV1_stressed', null, { child: { withIcon: true } }),
  customV1_being_home_alone: wrapStepQuestions(WithOneOptionV1, 'customV1_being_home_alone', null, { child: { withIcon: true } }),
  customV1_walk: wrapStepQuestions(WithOneOptionV1, 'customV1_walk'),
  customV1_hygiene: wrapStepQuestions(WithOneOptionV1, 'customV1_hygiene', null, { child: { withIcon: true } }),
  customV1_concern: wrapStepQuestions(MultiOptionsV2, 'customV1_concern'),
  customV1_dangerous_situation: wrapStepQuestions(WithOneOptionV1, 'customV1_dangerous_situation', null, { child: { withIcon: true } }),
  customV1_these_commands: wrapStepQuestions(WithOneOptionV1, 'customV1_these_commands', null, { child: { withIcon: true, withDescriptionText: true } }),
  customV1_eat_something_bad: wrapStepQuestions(WithOneOptionV1, 'customV1_eat_something_bad', null, { child: { withIcon: true } }),
  customV1_this_command: wrapStepQuestions(WithOneOptionV1, 'customV1_this_command', null, { child: { withIcon: true, withDescriptionText: true } }),
  customV1_afraid: wrapStepQuestions(WithOneOptionV1, 'customV1_afraid', null, { child: { withIcon: true } }),
  customV1_descriptionV2: wrapStepQuestions(DescriptionV2, 'customV1_descriptionV2'),
  customV1_startPage: wrapStepQuestions(StartPage, 'customV1_descriptionV2'),
  customV1_when_called: wrapStepQuestions(WithOneOptionV1, 'customV1_when_called', null, { child: { withIcon: true, withDescriptionText: true } }),
  customV1_when_chews: wrapStepQuestions(WithOneOptionV1, 'customV1_when_chews', null, { child: { withIcon: true } }),
  customV1_boundaries: wrapStepQuestions(WithOneOptionV1, 'customV1_boundaries', null, { child: { withIcon: true, withDescriptionText: true } }),
  customV1_hard_training: wrapStepQuestions(WithOneOptionV1, 'customV1_hard_training', null, { child: { withIcon: true } }),
  customV1_main_goal: wrapStepQuestions(MultiOptionsV1, 'customV1_main_goal', null, { child: { withWideButtons: true } }),
  customV1_training_time: wrapStepQuestions(WithOneOptionV1, 'customV1_training_time'),
  customV1_loader: wrapStepQuestions(LoaderV2, 'customV1_loader'),
  customV1_email: wrapStep(MailV2, { wrapper: { isCurrentStepCompleted: true } }),

  // custom V2
  customV2_startPage: wrapStepQuestions(CustomV2StartPage, 'customV2_startPage'),
  customV2_policyPage: wrapStepQuestions(CustomV2PolicyPage, 'customV2_policyPage'),
  customV2_policyPageV2: wrapStepQuestions(CustomV2PolicyPageV2, 'customV2_policyPageV2'),
  customV2_policyPageV3: wrapStepQuestions(CustomV2PolicyPageV3, 'customV2_policyPageV3'),
  customV2_policyPageV4: wrapStepQuestions(CustomV2PolicyPageV4, 'customV2_policyPageV4'),
  customV2_policyPageV5: wrapStepQuestions(CustomV2PolicyPageV5, 'customV2_policyPageV5'),
  customV2_videoPolicyPage: wrapStepQuestions(CustomV2VideoPolicyPage, 'customV2_videoPolicyPage'),
  customV2_start_page_video: wrapStepQuestions(StartPageVideo, 'customV2_start_page_video'),
  customV2_start_page_video_v2: wrapStepQuestions(StartPageVideoV2, 'customV2_start_page_video_v2'),
  customV2_startPageV2: wrapStepQuestions(CustomV2StartPageV2, 'customV2_startPageV2'),
  customV2_startPageV3: wrapStepQuestions(CustomV2StartPageV3, 'customV2_startPageV3'),
  customV2_startPageV4: wrapStepQuestions(DynamicCustomV2StartPage, 'customV2_startPageV4'),
  customV2_startPageV5: wrapStepQuestions(CustomV2StartPageV5, 'customV2_startPageV5'),
  customV2_startPageV6: wrapStepQuestions(CustomV2StartPageV6, 'customV2_startPageV6'),
  customV2_startPageGender: wrapStepQuestions(StartPageGender, 'customV2_startPageGender', null, { child: { withIcon: true } }),
  customV2_startPageV7: wrapStepQuestions(CustomV2StartPageV7, 'customV2_startPageV7'),
  customV2_startPageV8: wrapStepQuestions(CustomV2StartPageV8, 'customV2_startPageV8'),
  customV2_startPageV11: wrapStepQuestions(CustomV2StartPageV11, 'customV2_startPageV11'),
  customV2_startPageV12: wrapStepQuestions(CustomV2StartPageV12, 'customV2_startPageV12'),
  customV2_startPageV13: wrapStepQuestions(CustomV2StartPageV13, 'customV2_startPageV13'),
  customV2_startPageV17: wrapStepQuestions(CustomV2StartPageV17, 'customV2_startPageV17'),
  customV2_startPageV18: wrapStepQuestions(CustomV2StartPageV18, 'customV2_startPageV18'),
  customV2_startPageV19: wrapStepQuestions(CustomV2StartPageV19, 'customV2_startPageV19'),
  customV2_startPageV20: wrapStepQuestions(CustomV2StartPageV20, 'customV2_startPageV20'),
  customV2_startPageV21: wrapStepQuestions(CustomV2StartPageV21, 'customV2_startPageV21'),
  customV2_startPageV22: wrapStepQuestions(CustomV2StartPageV22, 'customV2_startPageV22'),
  customV2_startPageV23: wrapStepQuestions(CustomV2StartPageV23, 'customV2_startPageV23'),
  customV2_startPageV24: wrapStepQuestions(CustomV2StartPageV24, 'customV2_startPageV24'),
  customV2_startPageV25: wrapStepQuestions(CustomV2StartPageV25, 'customV2_startPageV25'),
  customV2_startPageV26: wrapStepQuestions(CustomV2StartPageV26, 'customV2_startPageV26'),
  customV2_startPageV27: wrapStepQuestions(CustomV2StartPageV27, 'customV2_startPageV27'),
  customV2_startPageV28: wrapStepQuestions(CustomV2StartPageV28, 'customV2_startPageV28'),
  customV2_startPageV29: wrapStepQuestions(CustomV2StartPageV29, 'customV2_startPageV29'),
  customV2_startPageV30: wrapStepQuestions(CustomV2StartPageV30, 'customV2_startPageV30'),
  customV2_startPageV31: wrapStepQuestions(CustomV2StartPageV31, 'customV2_startPageV31'),

  customV2_gender: (stepData) => withSuspense(
    <StepWrapper stepData={stepData} questions={cachedOne('customV2_gender')}>
      <WithOneOptionV2 withIcon />
    </StepWrapper>,
  ),

  customV3_gender: wrapStepQuestions(GenderV3, 'customV3_gender', null, { child: { withIcon: true } }),
  customV2_name: wrapStep(DogNameV2, { wrapper: { customIsCompletedValidation: true } }),
  customV2_age: wrapStepQuestions(WithOneOptionV3, 'customV2_age'),
  customV2_breed: wrapStep(DogBreed, { wrapper: { customIsCompletedValidation: true } }),

  customV2_health: wrapStepQuestions(CustomV2MultiOptionsV1, 'customV2_health', {
    isResetAnswer: { index: 'v1', value: 'My dog is healthy' },
  }),
  customV2_potty: wrapStepQuestions(CustomV2MultiOptionsV1, 'customV2_potty', {
    isResetAnswer: { index: 'v4', value: 'All good, no issues!' },
  }),
  customV2_issues: wrapStepQuestions(CustomV2MultiOptionsV1, 'customV2_issues'),
  customV2_issues_2: wrapStepQuestions(CustomV2MultiOptionsV1, 'customV2_issues_2'),

  customV2_walking_issues: wrapStepQuestions(CustomV2MultiOptionsV1, 'customV2_walking_issues', {
    isResetAnswer: { index: 'v1', value: 'My dog doesnt walk out yet' },
  }),

  customV2_activity: wrapStepQuestions(WithOneOptionV2, 'customV2_activity', null, { child: { withIcon: true } }),
  customV2_training_time: wrapStepQuestions(WithOneOptionV2, 'customV2_training_time'),
  customV2_training: wrapStepQuestions(WithOneOptionV2, 'customV2_training', null, { child: { withIcon: true } }),

  customV2_command_1: wrapStepQuestions(CustomV2MultiOptionsV2, 'customV2_command_1'),
  customV2_command_2: wrapStepQuestions(CustomV2MultiOptionsV2, 'customV2_command_2'),
  customV2_command_3: wrapStepQuestions(CustomV2MultiOptionsV2, 'customV2_command_3'),
  customV2_command_4: wrapStepQuestions(CustomV2MultiOptionsV2, 'customV2_command_4'),

  customV2_info_breed: wrapStepQuestions(CustomV2InfoBreed, 'customV2_info_breed'),
  customV2_info_breed_2: wrapStepQuestions(CustomV2InfoBreedV2, 'customV2_info_breed_2'),
  customV2_info_breed_3: wrapStepQuestions(CustomV2InfoBreedV3, 'customV2_info_breed_3'),
  customV2_creating_program: wrapStepQuestions(CustomV2CreatingProgram, 'customV2_creating_program'),

  customV2_email: wrapStep(MailV3, { wrapper: { isCurrentStepCompleted: true } }),
  customV2_plan: wrapStepQuestions(Plan, 'customV2_plan'),

  customV4_behavior_problem: wrapStepQuestions(BehaviorProblemV4, 'customV4_behavior_problem'),
  customV5_behavior_problem: wrapStepQuestions(WithOneOptionV4V5, 'customV5_behavior_problem', null, { child: { withIcon: true } }),

  customV2_age_v2: wrapStepQuestions(AgeV2, 'customV2_age_v2'),
  customV2_age_v3: wrapStepQuestions(AgeV3, 'customV2_age_v3'),
  customV2_age_v4: wrapStepQuestions(AgeV4, 'customV2_age_v4'),
  customV2_age_v5: wrapStepQuestions(AgeV5, 'customV2_age_v5'),

  customV2_reason: wrapStepQuestions(WithOneOptionV5, 'customV2_reason', null, { child: { withIcon: true } }),
  customV2_date: wrapStep(DateStep, { wrapper: { customIsCompletedValidation: true } }),
  customV2_info_predict: wrapStepQuestions(InfoPredict, 'customV2_info_predict'),

  customV2_food: wrapStepQuestions(CustomV2MultiOptionsV1, 'customV2_food', {
    isResetAnswer: { index: 'v4', value: 'Special dietary food' },
  }),

  issues_biting: wrapStepQuestions(WithOneOptionV6, 'issues_biting', null, { child: { withIcon: true } }),
  issues_damage: wrapStepQuestions(WithOneOptionV6, 'issues_damage', null, { child: { withIcon: true } }),
  issues_crate: wrapStepQuestions(WithOneOptionV6, 'issues_crate', null, { child: { withIcon: true } }),
  issues_home: wrapStepQuestions(WithOneOptionV2, 'issues_home', null, { child: { withIcon: true } }),
  follow_commands: wrapStepQuestions(WithOneOptionV2, 'follow_commands', null, { child: { withIcon: true } }),
  get_irritated: wrapStepQuestions(WithOneOptionV2, 'get_irritated', null, { child: { withIcon: true } }),
  raise_voice: wrapStepQuestions(WithOneOptionV2, 'raise_voice', null, { child: { withIcon: true } }),
  hit_dog: wrapStepQuestions(WithOneOptionV6, 'hit_dog', null, { child: { withIcon: true } }),
  how_attached: wrapStepQuestions(WithOneOptionV2, 'how_attached', null, { child: { withIcon: true } }),

  info_thank: wrapStepQuestions(InfoThank, 'info_thank'),
  info_about_potty: wrapStepQuestions(InfoAboutPotty, 'info_about_potty'),

  potty_how_long: wrapStepQuestions(WithOneOptionV7, 'potty_how_long', null, { child: { withIcon: true, showBottomBar: true } }),
  potty_where: wrapStepQuestions(WithOneOptionV7, 'potty_where', null, { child: { withIcon: true, btn: 'skip' } }),
  potty_how_often_walks: wrapStepQuestions(WithOneOptionV7, 'potty_how_often_walks', null, { child: { btn: 'none' } }),
  potty_health_issues: wrapStepQuestions(WithOneOptionV2, 'potty_health_issues', null, { child: { withIcon: true } }),
  potty_where_want: wrapStepQuestions(WithOneOptionV2, 'potty_where_want', null, { child: { withIcon: true } }),
  info_about_owner: wrapStepQuestions(InfoAboutOwner, 'info_about_owner'),

  training_raise_voice: wrapStepQuestions(WithOneOptionV2, 'training_raise_voice', null, { child: { withIcon: true } }),
  training_react_to_punishment: wrapStepQuestions(WithOneOptionV2, 'training_react_to_punishment', null, { child: { withIcon: true } }),

  owner_feelings: wrapStepQuestions(WithOneOptionV2, 'owner_feelings', null, { child: { withIcon: true } }),
  owner_sleep: wrapStepQuestions(WithOneOptionV2, 'owner_sleep', null, { child: { withIcon: true } }),
  owner_puppy_behavior: wrapStepQuestions(WithOneOptionV2, 'owner_puppy_behavior', null, { child: { withIcon: true } }),
  owner_puppy_managing: wrapStepQuestions(WithOneOptionV2, 'owner_puppy_managing', null, { child: { withIcon: true } }),
  owner_puppy_affect: wrapStepQuestions(WithOneOptionV2, 'owner_puppy_affect', null, { child: { withIcon: true } }),
  owner_support: wrapStepQuestions(WithOneOptionV2, 'owner_support', null, { child: { withIcon: true } }),
  owner_concerns: wrapStepQuestions(CustomV2MultiOptionsV1, 'owner_concerns'),

  statement_irritation: wrapStepQuestions(WithTrackOption, 'statement_irritation'),
  statement_ignore_commands: wrapStepQuestions(WithTrackOption, 'statement_ignore_commands'),
  statement_strong_bond: wrapStepQuestions(WithTrackOption, 'statement_strong_bond'),

  customV2_quote: wrapStep(Quote, { wrapper: { customIsCompletedValidation: true } }),
  main_goal: wrapStepQuestions(WithOneOptionV2, 'main_goal', null, { child: { withIcon: true } }),
  receive_email: wrapStep(ReceiveEmail, { wrapper: { isCurrentStepCompleted: true } }),

  gender_zw: wrapStepQuestions(GenderZw, 'customV3_gender', null, { child: { withIcon: true } }),
  zw_age: wrapStepQuestions(ZwAge, 'customV2_age', null, { child: { withIcon: true } }),

  customV2_potty_v2: wrapStepQuestions(CustomV2MultiOptionsV1, 'customV2_potty_v2', {
    isResetAnswer: { index: 'v6', value: 'My dog is potty trained!' },
  }),

  customV2_specialOffer: wrapStep(SpecialOffer, { wrapper: { isCurrentStepCompleted: true } }),
  customV2_specialOffer_v2: wrapStep(SpecialOfferV2, { wrapper: { isCurrentStepCompleted: true } }),
  customV2_specialOffer_v3: wrapStep(SpecialOfferV3, { wrapper: { isCurrentStepCompleted: true } }),

  start_page_age: wrapStepQuestions(StartPageAge, 'start_page_age'),
  start_page_age_v2: wrapStepQuestions(StartPageAgeV2, 'start_page_age_v2'),
  start_page_age_v3: wrapStepQuestions(StartPageAgeV3, 'start_page_age_v3'),
  training_time: wrapStepQuestions(TrainingTime, 'training_time'),
  crate_trained: wrapStepQuestions(WithOneOptionV2, 'crate_trained', null, { child: { withIcon: true } }),
  info_about_crate: wrapStepQuestions(InfoAboutCrate, 'info_about_crate'),
  accidents_how_often: wrapStepQuestions(WithOneOptionV2, 'accidents_how_often', null, { child: { withIcon: true } }),
  accidents_what_do: wrapStepQuestions(CustomV2MultiOptionsV1, 'accidents_what_do'),
  concern_toilet_training: wrapStepQuestions(CustomV2MultiOptionsV1, 'concern_toilet_training'),
  info_about_potty_struggles: wrapStepQuestions(InfoAboutCrate, 'info_about_potty_struggles'),
  puppy_issues_at_home: wrapStepQuestions(CustomV2MultiOptionsV1, 'puppy_issues_at_home'),
  puppy_chew: wrapStepQuestions(CustomV2MultiOptionsV1, 'puppy_chew'),
  puppy_bite_hands: wrapStepQuestions(WithOneOptionV2, 'puppy_bite_hands', null, { child: { withIcon: true } }),
  puppy_leave_house: wrapStepQuestions(WithOneOptionV2, 'puppy_leave_house', null, { child: { withIcon: true } }),
  fix_behavior_issues: wrapStepQuestions(CustomV2MultiOptionsV1, 'fix_behavior_issues', {
    isResetAnswer: { index: 'v5', value: 'Nothing yet' },
  }),
  info_about_training: wrapStepQuestions(InfoAboutTraining, 'info_about_training'),
  puppy_commands: wrapStepQuestions(CustomV2MultiOptionsV2, 'puppy_commands'),
  first_puppy: wrapStepQuestions(WithOneOptionV2, 'first_puppy', null, { child: { withIcon: false } }),
  age_group: wrapStepQuestions(WithOneOptionV2, 'age_group', null, { child: { withIcon: false } }),
  understanding: wrapStepQuestions(WithOneOptionV2, 'understanding', null, { child: { withIcon: true } }),
  info_about_understanding: wrapStepQuestions(InfoAboutUnderstanding, 'info_about_understanding'),
  understanding_when: wrapStepQuestions(CustomV2MultiOptionsV1, 'understanding_when'),
  understanding_real_time: wrapStepQuestions(CustomV2MultiOptionsV1, 'understanding_real_time'),
  understanding_summary: wrapStepQuestions(UnderstandingSummary, 'understanding_summary'),
};
